import { useTranslation } from "react-i18next";
import { ShieldCheck, Activity, Bug, Zap, ShieldX } from "lucide-react";

const SolutionDescription = ({ solutionKey }) => {
  const { t } = useTranslation();

  const renderCards = () => {
    switch (solutionKey) {
      case "soc":
        return (
          <div className="mt-8 grid grid-cols-3 tablet:grid-cols-1 gap-4">
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-5 text-center">
              <Activity className="w-8 h-8 text-red-600 mx-auto mb-2" aria-hidden="true" />
              <p className="text-sm font-semibold text-gray-800">{t("solutions.soc.cardMonitoring")}</p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 text-center">
              <ShieldCheck className="w-8 h-8 text-blue-600 mx-auto mb-2" aria-hidden="true" />
              <p className="text-sm font-semibold text-gray-800">{t("solutions.soc.cardThreat")}</p>
            </div>
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-5">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{t("solutions.soc.cardPlatform")}</p>
              <p className="text-sm text-gray-600">{t("solutions.soc.cardPlatformDesc")}</p>
            </div>
          </div>
        );
      case "vapt":
        return (
          <div className="mt-8 grid grid-cols-3 tablet:grid-cols-1 gap-4">
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-5 text-center">
              <Bug className="w-8 h-8 text-amber-600 mx-auto mb-2" aria-hidden="true" />
              <p className="text-sm font-semibold text-gray-800">{t("solutions.vapt.cardEffort")}</p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 text-center">
              <Zap className="w-8 h-8 text-blue-600 mx-auto mb-2" aria-hidden="true" />
              <p className="text-sm font-semibold text-gray-800">{t("solutions.vapt.cardHours")}</p>
            </div>
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-5">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{t("solutions.vapt.cardPlatform")}</p>
              <p className="text-sm text-gray-600">{t("solutions.vapt.cardPlatformDesc")}</p>
            </div>
          </div>
        );
      case "firstprotect":
        return (
          <div className="mt-8 grid grid-cols-3 tablet:grid-cols-1 gap-4">
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-5 text-center">
              <ShieldX className="w-8 h-8 text-indigo-600 mx-auto mb-2" aria-hidden="true" />
              <p className="text-sm font-semibold text-gray-800">{t("solutions.firstprotect.cardPrevention")}</p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-5 text-center">
              <Zap className="w-8 h-8 text-blue-600 mx-auto mb-2" aria-hidden="true" />
              <p className="text-sm font-semibold text-gray-800">{t("solutions.firstprotect.cardLatency")}</p>
            </div>
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-5">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{t("solutions.firstprotect.cardPlatform")}</p>
              <p className="text-sm text-gray-600">{t("solutions.firstprotect.cardPlatformDesc")}</p>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const hasCards = ["soc", "vapt", "firstprotect"].includes(solutionKey);

  return (
    <section className="py-20 tablet:py-16 px-6 mobile:px-4 bg-white">
      <div className="container-page">
        <div className="grid grid-cols-[220px_1fr] tablet:grid-cols-1 gap-10 tablet:gap-6 items-start border-t border-line pt-12">
          <div className="tablet:mb-2">
            <span className="kicker">Overview</span>
          </div>
          <div className="max-w-[68ch]">
            <p className="text-xl tablet:text-lg text-gray-700 leading-relaxed">
              {t(`solutions.${solutionKey}.description`)}
            </p>
            {hasCards && renderCards()}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionDescription;
